<template lang="pug">
  .menu-refund(ref="menuRefund")
    .menu-refund-item(@click="sendNotification")
      .menu-refund-item-text Enviar notificación
    .menu-refund-item(@click="openNotificationHistory")
      .menu-refund-item-text Historial de notificaciones
</template>

<script>
export default {
  name: 'MenuRefund',

  props: {
    index: {
      type: Number,
      required: true
    }
  },

  methods: {
    sendNotification () {
      this.$emit('sendNotification')
      this.$store.commit('hideMenu', this.index)
    },

    openNotificationHistory () {
      this.$emit('openNotificationHistory')
      this.$store.commit('hideMenu', this.index)
    }
  }
}
</script>

<style lang="stylus" scoped>
.menu-refund
  display flex
  flex-direction column
  border-radius 0.5em
  border 1px solid rgba(0,0,0,0.2)
  background-color #ffffff
  position absolute
  z-index 1000
  top 3em

.menu-refund-item
  padding .5em 1em
  cursor pointer

.menu-refund-item-text
  white-space nowrap

.menu-refund-item:hover
  background-color rgba(0,0,0,0.1)
</style>



// WEBPACK FOOTER //
// src/components/pages/refund/MenuRefund.vue